import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import { reactive, computed, toRefs, nextTick, watch, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { viewModeEnum, itemTypeEnum } from "@/enums/components/list";
import groupCard from "@/components/group-card";
import videoCard from "@/components/video-card";
import { UtilityService } from "@/utils";
export default {
  name: "list",
  components: {
    groupCard,
    videoCard
  },
  setup(props) {
    const route = useRoute();
    const {
      groupData,
      toExcludeLegacy,
      scrollToBottomHandler,
      isLastPage,
      dataPreprocessHandler,
      viewMode,
      isFinishQuery
    } = toRefs(props);
    const {
      getVideoType
    } = UtilityService;
    const state = reactive({
      viewModeType: viewModeEnum,
      isShowLegacy: false,
      lastCardLength: 0,
      isReadyforQuery: true,
      skeletonVideoCardInfo: new Array(0),
      groupCardInfo: computed(() => groupData.value.filter(item => item.type === itemTypeEnum.GROUP || item.type === itemTypeEnum.LINK)),
      processedVideoCards: computed(() => {
        return groupData.value.map(item => dataPreprocessHandler.value(item)).filter(item => item.type === itemTypeEnum.VIDEO || item.type === itemTypeEnum.SKILL_PATH);
      }),
      legacyVideoCards: computed(() => {
        if (toExcludeLegacy.value) {
          const legacyVideoCards = state.processedVideoCards.filter(item => item.isLegacy);
          return !isLastPage.value && toExcludeLegacy.value && legacyVideoCards.length > 0 ? [...legacyVideoCards, ...state.skeletonVideoCardInfo] : legacyVideoCards;
        } else {
          return [];
        }
      }),
      displayVideoCards: computed(() => {
        const displayVideoCards = toExcludeLegacy.value ? state.processedVideoCards.filter(item => !item.isLegacy) : state.processedVideoCards;
        return !isLastPage.value ? [...displayVideoCards, ...state.skeletonVideoCardInfo] : displayVideoCards;
      }),
      isShowVersionHeight: computed(() => {
        return state.processedVideoCards ? Boolean(state.processedVideoCards.find(card => card.productVersion)) : false;
      })
    });
    const maxHeight = element => {
      let currentMaxHeight = 0;
      $(element).each(function () {
        if ($(this).outerHeight() > currentMaxHeight) {
          currentMaxHeight = $(this).outerHeight();
        }
      });
      return currentMaxHeight;
    };
    const generateSkeletonVideoCardInfo = () => {
      const dummyVideoCard = {
        isSkeleton: true
      };
      function totalItem(rowNumber) {
        if (state.processedVideoCards.length % rowNumber > 0) {
          return rowNumber - state.processedVideoCards.length % rowNumber + rowNumber;
        } else {
          return rowNumber * 2;
        }
      }
      if (viewMode.value === state.viewModeType.DETAILS) {
        state.skeletonVideoCardInfo = new Array(2).fill(dummyVideoCard);
      } else {
        if ($(window).width() > 1450) {
          state.skeletonVideoCardInfo = new Array(totalItem(4)).fill(dummyVideoCard);
        } else if ($(window).width() > 971) {
          state.skeletonVideoCardInfo = new Array(totalItem(3)).fill(dummyVideoCard);
        } else if ($(window).width() > 610) {
          state.skeletonVideoCardInfo = new Array(totalItem(2)).fill(dummyVideoCard);
        } else {
          state.skeletonVideoCardInfo = new Array(2).fill(dummyVideoCard);
        }
      }
    };
    generateSkeletonVideoCardInfo();
    watch(() => viewMode.value, () => {
      generateSkeletonVideoCardInfo();
    });
    watch(() => route.query, () => {
      state.isShowLegacy = false;
    });
    watch(() => isFinishQuery.value, () => {
      if (isFinishQuery.value) {
        nextTick(() => {
          const videoCards = groupData.value.filter(item => item.type === itemTypeEnum.VIDEO);
          if ($(".video-card").eq(state.lastCardLength).offset() && $(".el-skeleton").eq(0).offset() && Math.ceil($(window).scrollTop()) + Math.ceil($(window).height()) > $(".el-skeleton").eq(0).offset().top) {
            $('html, body').animate({
              scrollTop: $(".video-card").eq(state.lastCardLength).offset().top - $(".video-card").height()
            }, {
              complete: function () {
                state.isReadyforQuery = true;
                state.lastCardLength = videoCards.length;
              }
            });
          } else {
            state.isReadyforQuery = true;
            state.lastCardLength = videoCards.length;
          }
        });
      }
    });
    let resizeEvent;
    nextTick(() => {
      let scrollToBottomTimer = null;
      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var windowHeight = $(this).height();
        if (groupData.value.length > 0 && $(".el-skeleton").eq(0).offset() && Math.ceil(scrollTop) + Math.ceil(windowHeight) >= $(".el-skeleton").eq(0).offset().top && state.isReadyforQuery && !isLastPage.value) {
          state.isReadyforQuery = false;
          clearTimeout(scrollToBottomTimer);
          scrollToBottomTimer = setTimeout(() => {
            scrollToBottomHandler.value();
          }, 250);
        }
      });
      let groupCardMaxHightTimer = null;
      resizeEvent = function () {
        clearTimeout(groupCardMaxHightTimer);
        groupCardMaxHightTimer = setTimeout(() => {
          generateSkeletonVideoCardInfo();
          $('.group-card').css('min-height', maxHeight('.group-card'));
        }, 250);
      };
      window.addEventListener("resize", resizeEvent);
      setTimeout(() => {
        $('.group-card').css('min-height', maxHeight('.group-card'));
      }, 0);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", resizeEvent);
    });
    return {
      state,
      resizeEvent
    };
  },
  props: {
    viewMode: {
      type: Number,
      required: true
    },
    groupData: {
      type: Array,
      required: true
    },
    toExcludeLegacy: {
      type: Boolean,
      required: true
    },
    impressionHandler: {
      type: Function,
      required: true,
      default() {
        return () => true;
      }
    },
    clickCardHandler: {
      type: Function,
      required: true,
      default() {
        return () => true;
      }
    },
    scrollToBottomHandler: {
      type: Function,
      required: true,
      default() {
        return () => true;
      }
    },
    clickBookmarkHandler: {
      type: Function,
      required: true,
      default() {
        return () => true;
      }
    },
    dataPreprocessHandler: {
      type: Function,
      required: true,
      default: function (item) {
        return item;
      }
    },
    isLastPage: {
      type: Boolean,
      required: true
    },
    langPath: {
      type: String,
      required: true
    },
    errorMsg: {
      type: String,
      required: false,
      default: ''
    },
    isFinishQuery: {
      type: Boolean
    },
    isShowDeleteHistoryButton: {
      type: Boolean,
      default: false,
      required: false
    },
    deleteHistoryHandler: {
      type: Function,
      required: false,
      default() {
        return () => true;
      }
    }
  }
};